import {
  ComponentTypeEnum,
  isValidButtonDefinition,
  isValidLinkDefinition,
  isValidTitleDefinition,
} from "./components";

const COMPONENT_TYPES = Object.values(ComponentTypeEnum).reduce((types, value) => ({ ...types, [value]: true }), {});

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getComponentValidator = (type: ComponentTypeEnum): ((data: any) => boolean) => {
  switch (type) {
    case ComponentTypeEnum.Button:
      return isValidButtonDefinition;
    case ComponentTypeEnum.Link:
      return isValidLinkDefinition;
    case ComponentTypeEnum.Title:
      return isValidTitleDefinition;
    default:
      // @ts-expect-error TS(2322): Type 'null' is not assignable to type '(data: any)... Remove this comment to see the full error message
      return null;
  }
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isValidComponentDefinition(component: any): boolean {
  const { type, data } = component;

  // @ts-expect-error TS(2571): Object is of type 'unknown'.
  if (!type || !COMPONENT_TYPES[type]) {
    return false;
  }

  const validateComponent = getComponentValidator(type);

  return validateComponent ? validateComponent(data) : true;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isValidComponentsDefinition(components: any[]): boolean {
  return components.every(isValidComponentDefinition);
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isValidSectionDefinition(section: any): boolean {
  const { title, components } = section;

  if (!title || !components || !Array.isArray(components)) {
    return false;
  }

  return isValidComponentsDefinition(components);
}
